class RichtextWithImage extends HTMLElement {
  connectedCallback() {
    this.media = this.querySelector('[data-rwi-parallax]');
    if (!this.media) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduceMotion.matches) return;

    this.strength = parseFloat(this.style.getPropertyValue('--rwi-parallax-strength')) || 0;
    if (this.strength <= 0) return;

    this.ticking = false;
    this.onScroll = this.onScroll.bind(this);

    // Scale the media so vertical translation never reveals empty edges.
    const overscan = 1 + this.strength * 2;
    this.media.style.transform = `scale(${overscan})`;
    this.baseScale = overscan;

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  }

  update() {
    const rect = this.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    if (rect.bottom < 0 || rect.top > viewportHeight) return;

    // Progress: -1 (entering bottom) → 1 (leaving top), 0 at viewport center.
    const progress = (rect.top + rect.height / 2 - viewportHeight / 2) / viewportHeight;
    const offset = progress * rect.height * this.strength;

    this.media.style.transform = `scale(${this.baseScale}) translateY(${(-offset / this.baseScale).toFixed(2)}px)`;
  }
}

customElements.define('richtext-with-image', RichtextWithImage);
